export default [
  {
    id: "LBI7cgq3pbM",
    thumb:
      "https://images.unsplash.com/photo-1604341260903-9201d604dc95?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    source:
      "https://images.unsplash.com/photo-1604341260903-9201d604dc95?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Woman in black",
  },
  {
    id: "fdgdfgdfg",
    thumb:
      "https://images.unsplash.com/photo-1562814830-8286a3397045?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    source:
      "https://images.unsplash.com/photo-1562814830-8286a3397045?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Blue ocean",
  },
  {
    id: "1234sdfn",
    thumb:
      "https://images.unsplash.com/photo-1624268524134-fb42ea56bc03?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    source:
      "https://images.unsplash.com/photo-1624268524134-fb42ea56bc03?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "White concrete building",
  },
  {
    id: "fdg687rhs",
    thumb:
      "https://images.unsplash.com/photo-1624620178246-011ab2e9f0f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    source:
      "https://images.unsplash.com/photo-1624620178246-011ab2e9f0f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Concrete building",
  },
  {
    id: "htr67tje5",
    thumb:
      "https://images.unsplash.com/photo-1623717696183-e296b125cdb4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    source:
      "https://images.unsplash.com/photo-1623717696183-e296b125cdb4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Concrete building in daytime",
  },
  {
    id: "3465fgj778",
    thumb:
      "https://images.unsplash.com/photo-1520932767681-47fc69dd54e5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    source:
      "https://images.unsplash.com/photo-1520932767681-47fc69dd54e5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Woman in blue",
  },
  {
    id: "v6sryu6487",
    thumb:
      "https://images.unsplash.com/photo-1632604059861-1c8d446d5951?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    source:
      "https://images.unsplash.com/photo-1632604059861-1c8d446d5951?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Tall building",
  },
  {
    id: "sj0iotushba",
    thumb:
      "https://images.unsplash.com/photo-1618260242440-e832b310ebc7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=735&q=80",
    source:
      "https://images.unsplash.com/photo-1618260242440-e832b310ebc7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Snow covered mountain",
  },
  {
    id: "ghkjfa4sefgs",
    thumb:
      "https://images.unsplash.com/photo-1619453986741-43fe6066a86e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    source:
      "https://images.unsplash.com/photo-1619453986741-43fe6066a86e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Clouds",
  },
  {
    id: "lfzd34wgjha",
    thumb:
      "https://images.unsplash.com/photo-1523633625918-50cf36a42da5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=736&q=80",
    source:
      "https://images.unsplash.com/photo-1523633625918-50cf36a42da5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Photographer",
  },
];
